import React from 'react'
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from 'react-bootstrap/Modal';
import ModalHeader from '../../../components/ModalHeader';
import ModalBody from 'react-bootstrap/ModalBody';
import { Container, Row, Col, ModalFooter } from 'react-bootstrap';
import Button from '../../../components/Button';
import Blockquote from '../../../components/Blockquote/Blockquote';
import Tabs from '../../../components/Tabs/Tabs';
import HealthBenefits from '../../private/benefitCostWorksheetTabPages/healthBenefits_HQ';
import FlexibleSpendingAccounts from '../../private/benefitCostWorksheetTabPages/flexibleSpendingAccounts_HQ';
import DisabilityBenefits from '../../private/benefitCostWorksheetTabPages/disabilityBenefits_HQ';
import LifeInsurance from '../../private/benefitCostWorksheetTabPages/lifeInsurance_HQ'
import AllBenefits from '../../private/benefitCostWorksheetTabPages/allBenefits_HQ';

export type customBenefitOptionsCostsProps = {
    showBenefitOptionsCosts: boolean;
    handleCloseBenefitOptionsCosts: () => void;
  };

const BenefitOptionsCosts = ({
    showBenefitOptionsCosts,
    handleCloseBenefitOptionsCosts,
  }: customBenefitOptionsCostsProps) => {

    const tabsData = [
      {
        name: 'Health Benefits',
        content: <HealthBenefits />,
      },
      {
        name: 'Flexible Spending Accounts',
        content: <FlexibleSpendingAccounts />,
      },
      {
        name: 'Disability Benefits',
        content: <DisabilityBenefits />,
      },
      {
        name: 'Life Insurance',
        content: <LifeInsurance />,
      },
      {
        name: 'All Benefits',
        content: <AllBenefits />,
      },
    ];

  return (
    <Modal
      show={showBenefitOptionsCosts}
      onHide={handleCloseBenefitOptionsCosts}
      dialogClassName="modal-xl"
      className="custom-benefit-modal"
    >
      <ModalHeader closeButton withBorder>
        <h4 className="text-truncate">Benefit Cost Worksheet</h4>
      </ModalHeader>
      <ModalBody>
        <Container className={'col-12 border-bottom pb-10 mb-5'}>
          <Row>
            <Col className={'col-8 px-0 mt-2'}>
              {' '}
              <div>
                Event: <span className="fw-bold">Open Enrollment</span>
              </div>
              <div className={'mt-2'}>
                Date: <span className="fw-bold">1/1/2025</span>
              </div>
            </Col>
            <Col className={'col-4 text-end px-0 mt-3'}>
              <a
                className={'text-decoration-none'}
                href={`${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`}
                target={'_blank'}
                rel="noreferrer"
              >
                <Button
                  leftIcon={light('file-arrow-down')}
                  variant="primary"
                  className={'order-1 order-lg-3 mt-7 mt-lg-0'}
                  size="sm"
                >
                  Download/Print
                </Button>
              </a>
            </Col>
          </Row>
        </Container>
        <Row className="m-0 pb-12">
          <Blockquote>
            <span className="lh-xs">
              <p>
                <b>Important:</b> If you don't make a different election, you'll
                receive the highlighted coverage.
              </p>
              <p>
                <b>Note:</b>
              </p>
              <ul>
                <li>This worksheet is for planning purposes only.</li>
                <li>
                  Coverage eligibility may change depending on the actual date
                  of the event.
                </li>
                <li>
                  After you make new elections, your cost for coverages may
                  change.
                </li>
              </ul>
            </span>
          </Blockquote>
        </Row>

        <Row>
          <Col className="m-0 p-0 mt-12">
            <Tabs tabs={tabsData} variant={'horizontal'} />
          </Col>
        </Row>

      </ModalBody>
      <ModalFooter>
        <Button
          variant="primary-outline"
          onMouseDown={handleCloseBenefitOptionsCosts}
          className="mt-7 mt-lg-0 order-1"
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default BenefitOptionsCosts